export const SUCCESS_LANGUGES="SUCCESS_LANGUGES";
export const FAILED_LANGUGES="FAILED_LANGUGES";
export const REQUST_LANGUGES="REQUST_LANGUGES";
